import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlWeekProps extends ControlTemplateProps {
    
}

export const ControlWeek: React.FC<ControlWeekProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="week" {...ComponentProps(props)} style={{ ...styles.week ?? styles.date ?? styles.input, ...props.style }} />        
    );
};